import React, { useContext, useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import FloatingLabel from "react-bootstrap/FloatingLabel";

import Form from "react-bootstrap/Form";
import { useParams } from "react-router";

import ContextComponent from "../../../../AppContext";
import Utils from "../../../../Utils";

const EditLabelPage = ({ props }) => {

    const { siteid } = useParams();
    let [currSiteId, setCurrSiteId] = useState(siteid);

    let { setAlert, setLoadingState, setCanRedirectToLogin } = useContext(ContextComponent);
    let tableData = props?.tableData || [];

    let editableLabel = props?.editableLabel || {};
    let editableLabelIndex = props?.editableLabelIndex || {};
    let LABEL_TYPE = Utils.LABEL_TYPE || {};
    let [type, setType] = useState(editableLabel.labelType || LABEL_TYPE[0].value);
    console.log()

    const convertImageUrlToAbsolutePath = (imgPath) => {
        let absImagPath = Utils.getImagePath(imgPath)
        return absImagPath;
    };

    const convertAbsolutePathToRelativePath = (imgPath) => {
        let domain = Utils.getDomainName();

        if (imgPath && imgPath.includes(domain)) {
            return imgPath.replace(domain, "");
        }

        return imgPath;
    };


    let setTableData = props?.setTableData || (() => { });
    let [labelcode, setLabelcode] = useState(editableLabel.labelcode || "");
    let [labeltext, setLabeltext] = useState(editableLabel.labeltext || "");
    let [description, setDescription] = useState(editableLabel.description || "");
    let [image, setImage] = useState(editableLabel?.image ? convertImageUrlToAbsolutePath(editableLabel?.image) : "");

    const hideModal = (e) => {
        props.setEditModalCanOpen(false);
    };

    const updateLabel = (e) => {
        setLoadingState({
            applyMask: true,
            text: "Updating label",
        });
        const success = (res) => {
            hideModal();
            setLoadingState({
                applyMask: false,
            });
            setAlert({
                show: true,
                message: res?.data?.message
                    ? res.data.message
                    : "Label updated successfully!",
                type: "success",
            });
            props.loadFreshLabels(currSiteId);
        };
        const fail = (err) => {
            setLoadingState({
                applyMask: false,
            });
            if (err?.redirect) {
                setCanRedirectToLogin(true);
            }
            setAlert({
                show: true,
                message: err?.data?.message
                    ? err.data.message
                    : "Label edit failed",
                type: "error",
            });
            console.log(err);
        };

        let formData = {
            labelcode,
            description,
            labelType: type,
        };

        if (type === "TEXT") {
            formData = {
                ...formData,
                labeltext,
            };
        } else if (type === "IMAGE") {
            formData = {
                ...formData,
                image: convertAbsolutePathToRelativePath(image),
            };
        } else if (type === "ORDERED_LIST" || type === "UNORDERED_LIST") {
            formData = {
                ...formData,
                // orderedList: List,
            };
        }

        try {
            // console.log(editableLabel.id);
            // console.log(formData);
            Utils.updateLabel(editableLabel.id, formData).then(success, fail);
        } catch (e) {
            console.log(e);
        }
    };

    const labelcodeHandler = (e) => {
        let value = e?.currentTarget?.value || "";
        setLabelcode(value);
    };

    const labelTypeHandler = (e) => {
        setType(e.currentTarget.value);
    }

    const labeltextHandler = (e) => {
        let value = e?.currentTarget?.value || "";
        setLabeltext(value);
    };

    const onChangeImage = async (e) => {
        let file = e.currentTarget.files[0];
        let targetImage = e.currentTarget.attributes["imgname"].value;
        // let targetIndex = parseInt(
        //     e.currentTarget.attributes["imgindex"].value,
        //     10,
        // );
        document
            .querySelector(".indi-add-img-wrapper-" + targetImage)
            .classList.add("d-none");
        let imgPreviewEle = document.querySelector(
            ".indi-add-img-wrapper-preview-" + targetImage,
        );
        imgPreviewEle.classList.remove("d-none");
        await Utils.fileToDataUri(file).then((dataUri) => {
            imgPreviewEle.src = dataUri;
            setImage(dataUri);
            imgPreviewEle.src = dataUri;
        });
    };

    const labelDescriptionHandler = (e) => {
        let value = e?.currentTarget?.value || "";
        setDescription(value);
    };

    useEffect(() => { }, [props.editModalCanOpen]);

    const handleClose = (e) => {
        props.setEditModalCanOpen(false);
    };

    return (
        <>
            {
                <Modal centered show={props.editModalCanOpen} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Edit Label</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form>
                            <div className="indi-add-form-wrapper d-flex flex-column">
                                <div className="indi-add-form-item d-flex flex-column">
                                    <div className="indi-add-form-item-input row">
                                        <FloatingLabel label="Label Code">
                                            <Form.Control
                                                type="text"
                                                className="indi-input-field"
                                                id="labelcode"
                                                placeholder="Enter Label code"
                                                autoComplete="off"
                                                defaultValue={labelcode}
                                                onChange={labelcodeHandler}
                                            />
                                        </FloatingLabel>
                                    </div>
                                </div>
                                <div className="indi-add-form-item d-flex flex-column">
                                    <div className="indi-add-form-item-input row">
                                        <FloatingLabel label="Label Type">
                                            <Form.Select
                                                defaultValue={type}
                                                id="type"
                                                onChange={labelTypeHandler}
                                                size="sm"
                                                className="indi-input-field indi-input-select-field"
                                            >
                                                {LABEL_TYPE.map((label, index) => (
                                                    <option value={label.value} key={index}>
                                                        {label.name}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </FloatingLabel>
                                    </div>
                                </div>
                                {type === "TEXT" && (
                                    <div className="indi-add-form-item d-flex flex-column">
                                        <div className="indi-add-form-item-input row">
                                            <FloatingLabel label="Label Text">
                                                <Form.Control
                                                    as="textarea"
                                                    className="indi-input-field"
                                                    id="labeltext"
                                                    placeholder="Enter Label Text"
                                                    autoComplete="off"
                                                    defaultValue={labeltext}
                                                    onChange={labeltextHandler}
                                                />
                                            </FloatingLabel>
                                        </div>
                                    </div>
                                )}
                                {type === "IMAGE" && (
                                    <div className="indi-add-form-item d-flex row">
                                        <div className="indi-add-form-item-input col">
                                            <label htmlFor="iconImage" className="form-label">Label Image:</label>
                                            <div className="indi-add-form-item-input indi-upload-picture-file-input-wrapper">
                                                <input
                                                    type="file"
                                                    imgname="labelImage"
                                                    id="labelImage"
                                                    imgindex={0}
                                                    className="indi-upload-picture-file-input"
                                                    onChange={onChangeImage}
                                                />
                                                <div className="indi-add-img-wrapper"></div>
                                            </div>
                                        </div>
                                        <div className="indi-add-form-item-input col">
                                            <div className="indi-add-img-wrapper-labelImage d-none">no preview</div>
                                            <img
                                                src={image}
                                                alt="background"
                                                className="indi-add-img-wrapper-preview indi-add-img-wrapper-preview-labelImage"
                                            />
                                        </div>
                                    </div>
                                )}
                                <div className="indi-add-form-item d-flex flex-column">
                                    <div className="indi-add-form-item-input row">
                                        <FloatingLabel label="Label Description">
                                            <Form.Control
                                                as="textarea"
                                                className="indi-input-field"
                                                id="description"
                                                defaultValue={description}
                                                placeholder="Enter Label Description"
                                                autoComplete="off"
                                                onChange={labelDescriptionHandler}
                                            />
                                        </FloatingLabel>
                                    </div>
                                </div>
                            </div>
                            <div className="indi-add-footer">
                                <div className="indi-add-page-footer-btn-wrapper float-right">
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={hideModal}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={updateLabel}
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        </form>
                    </Modal.Body>
                </Modal>
            }
        </>
    );
}

export default EditLabelPage;